import { createRouter, createWebHashHistory, Router } from 'vue-router';
import { getToken, setToken } from '@/utils';
import { LoginApi } from '@/api';
import { useUserStore } from '@/stores/user.ts';
import { showToast } from 'vant';
import { clearWxOAuthParamsFromUrl, getWxOAuthCodeFromUrl, redirectToWxWorkOAuth } from '@/utils/wxOAuth';
// import { cloneDeep } from 'lodash-es';

const router: Router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{
			path: '/',
			redirect: '/portal',
		},
		{
			path: '/portal',
			name: 'Portal',
			meta: { title: '自助门户' },
			component: () => import('@/views/portalInfo/index.vue'),
		},
	{
		path: '/baseInfo',
		name: 'BaseInfo',
		meta: { title: '个人信息' },
		component: () => import('@/views/baseInfo/index.vue'),
	},
	{
		path: '/baseInfo/edit',
		name: 'BaseInfoEdit',
		meta: { title: '修改个人信息' },
		component: () => import('@/views/baseInfo/editInfo.vue'),
	},
		{
			path: '/timecard',
			name: 'Timecard',
			meta: { title: '月度核算' },
			component: () => import('@/views/timecard/index.vue'),
		},
		{
			path: '/myPerformance',
			name: 'MyPerformance',
			meta: { title: '我的绩效' },
			component: () => import('@/views/myPerformance/index.vue'),
		},
		{
			path: '/schemeConfirm',
			name: 'SchemeConfirm',
			meta: { title: '绩效方案确认' },
			component: () => import('@/views/myPerformance/schemeConfirm.vue'),
		},
		{
			path: '/performanceAchievement',
			name: 'PerformanceAchievement',
			meta: { title: '绩效成绩' },
			component: () => import('@/views/myPerformance/performanceAchievement.vue'),
		},
		{
			path: '/salary',
			name: 'Salary',
			meta: { title: '薪酬福利查询' },
			component: () => import('@/views/salary/index.vue'),
		},
		{
			path: '/gesture',
			name: 'Gesture',
			meta: { title: '薪酬福利查询' },
			component: () => import('@/views/salary/gesture.vue'),
		},
		{
			path: '/forget',
			name: 'Forget',
			meta: { title: '薪酬福利查询' },
			component: () => import('@/views/salary/forget.vue'),
		},
		{
			path: '/validor',
			name: 'Validor',
			meta: { title: '薪酬福利查询' },
			component: () => import('@/views/salary/validor.vue'),
		},
		{
			path: '/login',
			name: 'login',
			meta: { title: '登录' },
			component: () => import('@/views/login.vue'),
		},
	],
});
const whiteList = ['/login'];

router.beforeEach(async (to, _from, next) => {
	const {
		path,
		query: { code: routeCode },
		meta: { title },
	} = to;

	if (!whiteList.includes(path)) {
		const wxOAuthCode = getWxOAuthCodeFromUrl();
		const oauthCode = (wxOAuthCode || routeCode) as string | undefined;
		const token = getToken();

		if (!token && oauthCode) {
			const { code, msg, data } = await LoginApi.loginByCode(oauthCode as string);
			if (code !== 200) {
				showToast(msg);
				return;
			}
			if (data) {
				setToken(data);
			}
			clearWxOAuthParamsFromUrl();
		}

		const userStore = useUserStore();
		if (!userStore.user) {
			const res = await userStore.getUserInfo();
			if (!res || res.code !== 200) {
				setToken('');
				// const query = cloneDeep(to.query);
				// next({ ...to, query });
				if (!oauthCode && !getToken()) {
					try {
						const state = encodeURIComponent(to.fullPath);
						await redirectToWxWorkOAuth(state);
					} catch (error) {
						const errMsg = error instanceof Error ? error.message : '企业微信授权失败';
						showToast(errMsg);
					}
					return;
				}
				showToast(res?.msg||"登录已失效,即将刷新页面");
				return;
			}
		}
	}
	if (title) {
		document.title = title as string;
	}
	next();
});

export default router;
